import { range } from "lodash";
import moment from "moment";
import { DATETIME_MS_FORMAT } from "../../../../../helpers/Utils";

const dt = moment().add(-1, "days");

const CODIAX_DATA = range(0, 100).map((index) => ({
	id: index + 1,
	timestamp: dt
		.clone()
		.add(index + 1, "hour")
		.format(DATETIME_MS_FORMAT),
	data: "Here_is_a_long_data_row_fdjksfhduaifdhjksafbjksfndjksknfdjkfdms,fdsjfidlsfdksla,",
}));

export default CODIAX_DATA;
